import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Api100Service {

  constructor(
    private http: HttpClient
  ) { }

  getLotes(): Observable<any> {
    let url = environment.api100 + '/api-sap/v2/sd/proyectos/602/lotes';
    return this.http.get(url, {
      headers: {
        apikey: environment.api100Key,
      },
    });
  }

  getCategoriaLotes(): Observable<any> {
    let url = environment.api100 + '/api-sap/v2/sd/proyectos/602/categorias-lotes';
    return this.http.get(url, {
      headers: {
        apikey: environment.api100Key,
      },
    });
  }

  requestData(): Observable<any[]> {
    return forkJoin([this.getLotes(), this.getCategoriaLotes()]);
  }
}
